import { render, staticRenderFns } from "./DashboardOld.vue?vue&type=template&id=bae26474&scoped=true"
import script from "./DashboardOld.vue?vue&type=script&lang=js"
export * from "./DashboardOld.vue?vue&type=script&lang=js"
import style0 from "./DashboardOld.vue?vue&type=style&index=0&id=bae26474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae26474",
  null
  
)

export default component.exports